import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({theme}) => css`
    width: 16px;
    height: 16px;
    border-radius: 50%; 
    margin-left: 4px;
    background-color: ${theme?.colour?.secondary};

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    color: white;
  `}
`

export default Atom({ type: 'label', dataType: 'string', template })